import { render, staticRenderFns } from "./radioBtn.vue?vue&type=template&id=c1d15536&scoped=true"
import script from "./radioBtn.vue?vue&type=script&lang=js"
export * from "./radioBtn.vue?vue&type=script&lang=js"
import style0 from "./radioBtn.vue?vue&type=style&index=0&id=c1d15536&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1d15536",
  null
  
)

export default component.exports